const apiUrl = process.env.REACT_APP_API_URL;

export const fetchMedia = async (token, sortOrder, filters = {}) => {
  try {
    // sortOrder marad query paraméter
    const queryParams = new URLSearchParams();
    queryParams.append("sortOrder", sortOrder);

    const response = await fetch(
      `${apiUrl}/images/filter?${queryParams.toString()}`,
      {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(filters), // 🔥 minden filter a body-ban
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch media data");
    }

    const result = await response.json();

    const normalized = (result || []).map((item) => {
      const name =
        item.originalname ||
        item.name ||
        item.filename ||
        "unnamed";

      const category = item.category || item.categories || "";

      const uploadDateISO = item.upload_time
        ? new Date(item.upload_time * 1000).toISOString()
        : item.uploadDate || null;

      const creationDateISO = item.created_time
        ? new Date(item.created_time * 1000).toISOString()
        : item.creationDate || null;

      const thumbnailUrl =
        item.thumbnailUrl ||
        (item.filename && item.upload_time
          ? `/uploads/${item.image_type}s/${new Date(item.upload_time * 1000).getFullYear()}/${new Date(item.upload_time * 1000).getMonth() + 1
          }/${item.filename}`
          : item.url || "");

      return {
        ...item,
        name,
        category,
        uploadDate: uploadDateISO,
        creationDate: creationDateISO,
        thumbnailUrl,
      };
    });

    return normalized;
  } catch (error) {
    throw error;
  }
};

export const fetchDuplicateMedia = async (token, sortOrder, filters = {}) => {
  try {
    // sortOrder marad query paraméter
    const queryParams = new URLSearchParams();
    queryParams.append("sortOrder", sortOrder);

    const response = await fetch(
      `${apiUrl}/maintenance/duplicate-images?${queryParams.toString()}`,
      {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(filters), // 🔥 minden filter a body-ban
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch media data");
    }

    const result = await response.json();

    const normalized = (result || []).map((item) => {
      const name =
        item.originalname ||
        item.name ||
        item.filename ||
        "unnamed";

      const category = item.category || item.categories || item.category_ids || "";

      const uploadDateISO = item.upload_time
        ? new Date(item.upload_time * 1000).toISOString()
        : item.uploadDate || null;

      const creationDateISO = item.created_time
        ? new Date(item.created_time * 1000).toISOString()
        : item.creationDate || null;

      const thumbnailUrl =
        item.thumbnailUrl ||
        (item.filename && item.upload_time
          ? `/uploads/${item.image_type}s/${new Date(item.upload_time * 1000).getFullYear()}/${new Date(item.upload_time * 1000).getMonth() + 1
          }/${item.filename}`
          : item.url || "");

      return {
        ...item,
        name,
        category,
        uploadDate: uploadDateISO,
        creationDate: creationDateISO,
        thumbnailUrl,
      };
    });

    return normalized;
  } catch (error) {
    throw error;
  }
};



export const getImageById = async (token, id) => {
  try {
    const response = await fetch(`${apiUrl}/images/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      throw new Error('Failed to fetch image by ID');
    }
    return response.json();
  } catch (error) {
    throw error;
  }
};

export const editImage = async (token, id, imageData) => {
  try {
    const response = await fetch(`${apiUrl}/images/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(imageData),
    });
    if (!response.ok) {
      throw new Error('Failed to edit image');
    }
    return response.json();
  } catch (error) {
    throw error;
  }
};

export const addImage = async (token, imageData) => {
  try {
    const response = await fetch(`${apiUrl}/images`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(imageData),
    });
    if (!response.ok) {
      throw new Error('Failed to add image');
    }
    return response.json();
  } catch (error) {
    throw error;
  }
};

export const deleteImage = async (token, id) => {
  try {
    const response = await fetch(`${apiUrl}/images/${id}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      throw new Error('Failed to delete image');
    }
    return response.json();
  } catch (error) {
    throw error;
  }
};

export const getImageFileUrl = (id) => {
  return `${apiUrl}/images/file/${id}`;
};

export const getImageThumbnailUrl = (id) => {
  return `${apiUrl}/images/thumbnail/${id}`;
};

export const getVideoFileUrl = (id) => {
  return `${apiUrl}/videos/file/${id}`;
};
